import { useState } from "react";
import { getSocialIcon } from "../../utils/icons";
import RegisterModal from "../landing/RegisterModal";
import { addAlert } from "../../slices/alert";
import { useAppDispatch } from "../../hooks";
import { reopenCookieSettings } from "../../utils/cookieConsent";

const navigation = {
  information: [
    { name: "Terms of service", href: "/terms-of-service" },
    { name: "Privacy policy", href: "/privacy-policy" },
    { name: "Cookie policy", href: "/cookie-policy" },
  ],
  content: [
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
  ],
  social: [
  ],
};

export default function Footer({
  bgColour = "off-white",
}: {
  bgColour?: string;
}) {

  const dispatch = useAppDispatch();
  const [showRegisterModal, setShowRegisterModal] = useState<boolean>(false);

  // Withdrawing consent has to be as easy as giving it, so the banner is
  // reachable from the footer of every page.
  function openCookieSettings(e: React.MouseEvent) {
    e.preventDefault();
    if (!reopenCookieSettings()) {
      dispatch(addAlert("The cookie banner could not be opened. It may be blocked by an ad blocker or browser extension.", "orange"));
    }
  }

  return (
    <>
      <RegisterModal show={showRegisterModal} setShow={setShowRegisterModal} />
      <footer
        className={`bg-${bgColour}`}
        aria-labelledby="footer-heading"
      >
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-8 md:py-12 grid grid-cols-1 sm:grid-cols-3">

          {/* Information */}
          <div className="text-dark-grey">
            <ul className="mt-6 space-y-4">
              {navigation.information.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm leading-6 font-bold"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#!"
                  onClick={openCookieSettings}
                  className="text-sm leading-6 font-bold"
                >
                  Cookie settings
                </a>
              </li>
            </ul>
          </div>

          {/* Content */}
          <div className="text-dark-grey">
            <ul className="mt-6 space-y-4">
              {navigation.content.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm leading-6 font-bold"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div className="text-dark-grey">

            {/* Icons */}
            <div className="flex flex-row gap-x-4 mt-6">
              <a
                href="https://www.facebook.com/raisediversity/"
                className="text-dark-grey"
                target="_blank"
              >
                <span className="sr-only">Facebook</span>
                {getSocialIcon("facebook", { className: "h-6 w-6" })}
              </a>
              <a
                href="https://www.instagram.com/raisediversity/"
                className="text-dark-grey"
                target="_blank"
              >
                <span className="sr-only">Instagram</span>
                {getSocialIcon("instagram", { className: "h-6 w-6" })}
              </a>
              <a
                href="https://www.linkedin.com/company/raisediversity/"
                className="text-dark-grey"
                target="_blank"
              >
                <span className="sr-only">LinkedIn</span>
                {getSocialIcon("linkedin-black", { className: "h-6 w-6" })}
              </a>
            </div>

            <ul className="mt-6 space-y-4">
              {/* {navigation.social.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm leading-6 font-bold"
                  >
                    {item.name}
                  </a>
                </li>
              ))} */}
              <li>
                <a
                  href="#!"
                  onClick={() => setShowRegisterModal(true)}
                  className="text-sm leading-6 font-bold"
                >
                  Become a member
                </a>
              </li>
            </ul>


          </div>
        </div>

        {/* Smallprint */}
        <div className="mx-auto max-w-7xl px-6 lg:px-8 pb-8 md:pb-12 grid grid-cols-1">
          <div className="mx-auto">
            <p className="text-xs text-dark-grey">
              RAISEDIVERSITY LIMITED, Company number 15964024, 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom
            </p>
            <p className="mt-2 text-xs text-dark-grey">
              We are committed to ensuring our website is accessible to all users, including those with disabilities. We strive to adhere to the accessibility standards set by the Web Content Accessibility Guidelines (WCAG) 2.1, aiming for Level AA compliance.
            </p>
            <p className="mt-2 text-xs text-dark-grey">
              {(new Date).getFullYear()} &copy; RaiseDiversity  All Rights Reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
